<template>
	<div class="header-menu">
		<div class="header-content">
			<!-- Left: Navigation Links -->
			<div class="nav-links">
				<router-link to="/" class="nav-item" active-class="active">首页</router-link>
				<router-link to="/course" class="nav-item" active-class="active">课程中心</router-link>
				<router-link to="/personal" class="nav-item" active-class="active">个人中心</router-link>
				<router-link to="/member" class="nav-item" active-class="active">会员服务</router-link>
			</div>

			<!-- Right: Search and Auth -->
			<div class="right-section">
				<!-- Search Bar -->
				<div class="search-bar">
					<input type="text" placeholder="请输入关键词搜索" v-model="searchKeyword" @keyup.enter="handleSearch" />
					<button class="search-btn" @click="handleSearch">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
							viewBox="0 0 16 16">
							<path
								d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
						</svg>
						搜索
					</button>
				</div>

				<!-- Auth Links -->
				<div class="auth-links" v-if="!isLoggedIn">
					<span class="login-trigger" @click="showLogin = true">请登录</span>
					<span class="divider" style="margin: 0 10px;">|</span>
					<span class="register-trigger" @click="$router.push('/register')">注册</span>
				</div>
				<div class="auth-links" v-else>
					<span>欢迎，{{ username || '用户' }}</span>
					<span class="divider" style="margin: 0 10px;">|</span>
					<a href="#" @click.prevent="logout">退出</a>
				</div>
			</div>
		</div>

		<!-- Login Modal -->
		<div class="login-modal-overlay" v-if="showLogin" @click.self="showLogin = false">
			<div class="modal-wrapper">
				<div class="login-modal">
					<!-- Header Image Area -->
					<div class="modal-header-bg" :style="{ backgroundImage: `url(${loginHeaderImg})` }">
						<div class="header-text">
							<!-- <img src="../assets/image/loginHeader.png" alt="" /> -->
						</div>
						<button class="close-btn" @click="showLogin = false">×</button>
					</div>

					<div class="modal-content">
						<!-- Tabs -->
						<div class="login-tabs">
							<div class="tab-item" :class="{ active: loginType === 'account' }"
								@click="loginType = 'account'">
								账号登录
							</div>
							<div class="divider">|</div>
							<div class="tab-item" :class="{ active: loginType === 'sms' }" @click="loginType = 'sms'">
								短信登录
							</div>
						</div>

						<!-- Account Login Form -->
						<div class="login-form" v-if="loginType === 'account'">
							<div class="input-group">
								<span class="input-icon user-icon">
									<img src="../assets/icon/userIcon.png" alt="" style="width: 20px;height: 20px;" />
								</span>
								<input type="text" placeholder="请输入手机号" v-model="loginForm.phone">
							</div>
							<div class="input-group">
								<span class="input-icon lock-icon">
									<img src="../assets/icon/passwordIcon.png" alt=""
										style="width: 20px;height: 20px;" />
								</span>
								<input :type="passwordVisible ? 'text' : 'password'" placeholder="请输入密码"
									v-model="loginForm.password">
								<span class="eye-icon" @click="passwordVisible = !passwordVisible">
									<svg v-if="!passwordVisible" viewBox="0 0 24 24" width="16" height="16"
										stroke="currentColor" stroke-width="2" fill="none">
										<path
											d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
										</path>
										<line x1="1" y1="1" x2="23" y2="23"></line>
									</svg>
									<svg v-else viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
										stroke-width="2" fill="none">
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
										<circle cx="12" cy="12" r="3"></circle>
									</svg>
								</span>
							</div>

							<div class="form-options">
								<label class="remember-me">
									<input type="checkbox" v-model="loginForm.rememberMe"> 记住密码
								</label>
								<span class="forgot-pwd" @click="$router.push('/forgot-password'); showLogin = false" style="cursor: pointer;">忘记密码?</span>
							</div>
							<div class="bottomButton">
								<button class="submit-btn" @click="handleLogin">立即登录</button>
								<button class="register-btn"
									@click="$router.push('/register'); showLogin = false;">免费注册</button>
							</div>

						</div>

						<!-- SMS Login Form -->
						<div class="login-form" v-else-if="loginType === 'sms'">
							<div class="input-group">
								<span class="input-icon mobile-icon">
									<img src="../assets/icon/userIcon.png" alt="" style="width: 20px;height: 20px;" />
								</span>
								<input type="text" placeholder="请输入手机号" v-model="loginForm.phone">
							</div>
							<div class="input-group">
								<span class="input-icon code-icon">
									<img src="../assets/icon/passwordIcon.png" alt=""
										style="width: 20px;height: 20px;" />
								</span>
								<input type="text" placeholder="请输入验证码" v-model="loginForm.code">
								<button class="send-code-btn" @click="sendVerifyCode" :disabled="isSending"
									:style="{ cursor: isSending ? 'not-allowed' : 'pointer', color: isSending ? '#999' : '#ff9900' }">{{ codeText }}</button>
							</div>
							<div class="bottomButton">
								<button class="submit-btn" @click="handleLogin">立即登录</button>
								<button class="register-btn"
									@click="$router.push('/register'); showLogin = false;">免费注册</button>
							</div>
						</div>

						<!-- Wechat Login Form -->
						<div class="login-form" v-else-if="loginType === 'wechat'">
							<div class="wechat-qrcode-container">
								<div id="wechat_login_container" class="qrcode-box"></div>
								<p class="scan-tip">请使用微信扫一扫登录</p>
							</div>
						</div>

						<!-- Footer -->
						<div class="modal-footer" v-if="loginType !== 'wechat'">
							<div class="wechat-login" @click="switchToWechatLogin">
								<div class="wechat-icon">
									<img src="../assets/icon/wechatLogin.png" alt="" />
								</div>
								<span>微信扫码登录</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import loginHeaderImg from '../assets/image/loginHeader.png';
	import {
		checkWechatLogin,
		login,
		sendCode
	} from '@/api/user';
	import eventBus from '@/utils/eventBus';
	import { ElMessage } from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'HeaderMenu',
		created() {
			this.checkLoginStatus();
			// Listen for login success event
			if (eventBus && eventBus.on) {
				eventBus.on('login-success', this.checkLoginStatus);
				eventBus.on('logout-success', this.checkLoginStatus);
			}
			// Load WeChat JS SDK
			this.loadWxScript();
		},
		data() {
			return {
				username: '',
				loginHeaderImg,
				isLoggedIn: false, // Change to true to simulate logged in state
				showLogin: false,
				loginType: 'account', // 'account' or 'sms' or 'wechat'
				passwordVisible: false,
				loginForm: {
					phone: '',
					password: '',
					code: '',
					rememberMe: false
				},
				searchKeyword: '',
				wechatTicket: '',
				pollTimer: null,
				codeText: '获取验证码',
				isSending: false,
				timer: null
			}
		},
		watch: {
			showLogin(val) {
				if (!val) {
					this.stopPolling();
					this.loginType = 'account';
				}
			},
			loginType(val) {
				if (val !== 'wechat') {
					this.stopPolling();
				}
			}
		},
		mounted() {
			// 监听全局“显示登录”事件（例如路由守卫触发）
			if (eventBus && eventBus.on) {
				eventBus.on('show-login', this.openLoginModal)
			}
		},
		methods: {
			openLoginModal() {
				this.showLogin = true
			},
			checkLoginStatus() {
				const token = localStorage.getItem('token');
				if (token) {
					this.isLoggedIn = true;
					const userInfo = localStorage.getItem('userInfo');
					if (userInfo) {
						try {
							const user = JSON.parse(userInfo);
							this.username = user.nickname
						} catch (e) {
							// ignore
						}
					}
				} else {
					this.isLoggedIn = false;
					this.username = '';
				}
			},
			handleSearch() {
				if (this.searchKeyword.trim()) {
					this.$router.push({
						path: '/course-more',
						query: {
							title: this.searchKeyword.trim()
						}
					});
				}
			},
			logout() {
				this.isLoggedIn = false;
				this.username = '';
				localStorage.removeItem('token');
				localStorage.removeItem('userInfo');
				if (eventBus && eventBus.emit) {
					eventBus.emit('logout-success');
				}
				// 如果在需要登录的页面，跳转到首页
				if (this.$route.path.includes('/personal') || this.$route.path.includes('/member')) {
					this.$router.push('/');
				}
				ElMessage.success('退出成功');
			},
			async switchToWechatLogin() {
				this.loginType = 'wechat';
				this.$nextTick(() => {
					this.initWxLogin();
				});
			},
			loadWxScript() {
				const script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
				document.head.appendChild(script);
			},
			initWxLogin() {
				const container = document.getElementById('wechat_login_container');
				if (container && window.WxLogin) {
					container.innerHTML = ''; // Clear previous
					new window.WxLogin({
						self_redirect: false,
						id: "wechat_login_container",
						appid: "wx01fb787df82dbbe2", // 替换为真实的 AppID
						scope: "snsapi_login",
						redirect_uri: encodeURIComponent(window.location.origin + '/callback'), // 跳转到回调页面
						state: "STATE",
						style: "black",
						href: ""
					});
				} else {
					// Retry if script not loaded
					setTimeout(() => {
						this.initWxLogin();
					}, 500);
				}
			},
			startPolling() {
				this.stopPolling();
				this.pollTimer = setInterval(async () => {
					try {
						// 假设 checkWechatLogin 需要 ticket
						// 如果没有 ticket，可能直接 check 或者不需要参数（通过 session/cookie）
						const res = await checkWechatLogin(this.wechatTicket);
						if (res && res.token) {
						// Store user info if present
						localStorage.setItem('token', res.token);
						let userInfo = null;
						if (res.userInfo) {
							userInfo = res.userInfo;
							localStorage.setItem('userInfo', JSON.stringify(userInfo));
						} else if (res.user) {
							userInfo = res.user;
							localStorage.setItem('userInfo', JSON.stringify(userInfo));
						}

						if (userInfo) {
							this.username = userInfo.nickname;
						}

						this.isLoggedIn = true;
						this.showLogin = false;
						this.stopPolling();
						if (eventBus && eventBus.emit) {
							eventBus.emit('login-success');
						}
						ElMessage.success('微信登录成功');
						}
					} catch (error) {
						// console.error('轮询检查失败', error);
					}
				}, 2000);
			},
			stopPolling() {
				if (this.pollTimer) {
					clearInterval(this.pollTimer);
					this.pollTimer = null;
				}
			},
			async sendVerifyCode() {
				if (this.isSending) return;

				const phone = this.loginForm.phone;
				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(phone)) {
					ElMessage.warning('请输入正确的手机号');
					return;
				}

				this.isSending = true;
				try {
					// type: 1 for login, adjust if API differs
					await sendCode({
						phone: phone,
						type: 1
					});

					// Start countdown
					let count = 60;
					this.codeText = `${count}s`;
					this.timer = setInterval(() => {
						count--;
						if (count > 0) {
							this.codeText = `${count}s`;
						} else {
							this.stopTimer();
						}
					}, 1000);

				} catch (error) {
					this.isSending = false;
					ElMessage.error(error.message || '发送验证码失败');
				}
			},
			stopTimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
				}
				this.isSending = false;
				this.codeText = '获取验证码';
			},
			async handleLogin() {
				const {
					phone,
					password,
					code
				} = this.loginForm;

				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}

				// type: 1=password, 2=code
				let data = {
					phone,
					type: this.loginType === 'account' ? 1 : 2
				};

				if (this.loginType === 'account') {
					if (!password) {
						ElMessage.warning('请输入密码');
						return;
					}
					data.password = password;
				} else if (this.loginType === 'sms') {
					if (!code) {
						ElMessage.warning('请输入验证码');
						return;
					}
					data.code = code;
				}

				try {
					const res = await login(data);
					// Check response structure
					if (res) {
						// Store token if present
						if (res.token) {
							localStorage.setItem('token', res.token);
						}
						// Store user info if present
						let userInfo = null;
						if (res.userInfo) {
							userInfo = res.userInfo;
							localStorage.setItem('userInfo', JSON.stringify(userInfo));
						} else if (res.user) {
							userInfo = res.user;
							localStorage.setItem('userInfo', JSON.stringify(userInfo));
						}

						if (userInfo) {
							this.username = userInfo.nickname;
						}

						this.isLoggedIn = true;
						this.showLogin = false;
						if (eventBus && eventBus.emit) {
							eventBus.emit('login-success');
						}
						ElMessage.success('登录成功');
						// Ideally update global state here
					} else {
						ElMessage.error('登录失败: 未知错误');
					}
				} catch (error) {
					console.error('Login error:', error);
					ElMessage.error(error.message || '登录失败');
				}
			}
		},
		beforeUnmount() {
			if (eventBus && eventBus.off) {
				eventBus.off('show-login', this.openLoginModal)
			}
			this.stopPolling();
			this.stopTimer();
		}
	}
</script>

<style scoped>
	.header-menu {
		width: 100%;
		background-color: #fff;
		border-bottom: 1px solid #e0e0e0;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	.header-content {
		max-width: 1200px;
		margin: 0 auto;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px;
	}

	.nav-links {
		display: flex;
		gap: 30px;
	}

	.nav-item {
		text-decoration: none;
		color: #333;
		font-size: 16px;
		padding: 18px 0;
		position: relative;
	}

	.nav-item.active {
		color: #ff9900;
		font-weight: bold;
	}

	.nav-item.active::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 3px;
		background-color: #ff9900;
	}

	.right-section {
		display: flex;
		align-items: center;
		gap: 30px;
	}

	.search-bar {
		display: flex;
		align-items: center;
		border: 1px solid #ddd;
		border-radius: 4px;
		overflow: hidden;
	}

	.search-bar input {
		border: none;
		padding: 8px 12px;
		outline: none;
		width: 200px;
		font-size: 14px;
	}

	.search-btn {
		background-color: #fff;
		border: none;
		border-left: 1px solid #ddd;
		padding: 8px 15px;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 5px;
		color: #666;
	}

	.search-btn:hover {
		background-color: #f5f5f5;
	}

	.auth-links {
		font-size: 14px;
		color: #666;
	}

	.auth-links a {
		text-decoration: none;
		color: #666;
	}

	.auth-links a:hover {
		color: #ff9900;
	}


	.login-trigger,
	.register-trigger {
		cursor: pointer;
	}

	.login-trigger:hover,
	.register-trigger:hover {
		color: #ff9900;
	}

	/* Modal Styles */
	.login-modal-overlay {
		position: fixed;
		top: 65px;
		/* Below header */
		left: 0;
		width: 100%;
		height: calc(100% - 60px);
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: flex-start;
		/* Start from top */
		z-index: 1000;
		padding-top: 0;
		/* Align with top of banner */
	}

	.modal-wrapper {
		width: 1200px;
		display: flex;
		justify-content: flex-end;
		padding: 0 20px;
		/* Match header padding */
		box-sizing: border-box;
	}

	.login-modal {
		width: 380px;
		background-color: #fff;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		/* margin-top: 20px; */
		/* Small gap from header */
	}

	.modal-header-bg {
		background: linear-gradient(135deg, #2b2b2b 0%, #4a4a4a 100%);
		color: #fff;
		padding: 25px 20px;
		position: relative;
		height: 100px;
		/* Placeholder image */
		background-size: cover;
		background-position: center;
	}


	.header-text {
		position: relative;
		z-index: 1;
	}

	.header-text h3 {
		margin: 0;
		font-size: 20px;
		font-weight: bold;
		color: #fff;
	}

	.header-text p {
		margin: 5px 0 0;
		font-size: 14px;
		opacity: 0.9;
	}

	.close-btn {
		position: absolute;
		top: 10px;
		right: 15px;
		background: none;
		border: none;
		color: #fff;
		font-size: 24px;
		cursor: pointer;
		z-index: 2;
		opacity: 0.7;
	}

	.close-btn:hover {
		opacity: 1;
	}

	.modal-content {
		padding: 20px 30px;
	}

	.login-tabs {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 25px;
		font-size: 16px;
	}

	.tab-item {
		cursor: pointer;
		padding: 0 10px;
		color: #666;
		position: relative;
	}

	.tab-item.active {
		color: #ff9900;
		font-weight: bold;
	}

	.tab-item.active::after {
		content: '';
		display: block;
		width: 60px;
		height: 2px;
		background: #ff9900;
		margin: 5px auto 0;
	}

	.login-form {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}

	.input-group {
		position: relative;
		display: flex;
		align-items: center;
	}

	.input-icon {
		position: absolute;
		left: 10px;
		color: #999;
		display: flex;
		align-items: center;
	}

	.input-group input {
		width: 100%;
		padding: 10px 10px 10px 35px;
		/* Space for icon */
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
		outline: none;
		transition: border-color 0.3s;
	}

	.input-group input:focus {
		border-color: #ff9900;
	}

	.eye-icon {
		position: absolute;
		right: 10px;
		cursor: pointer;
		color: #999;
		display: flex;
		align-items: center;
	}

	.send-code-btn {
		position: absolute;
		right: 5px;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: none;
		color: #ff9900;
		font-size: 13px;
		cursor: pointer;
		padding: 0 5px;
	}

	.form-options {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 13px;
		color: #666;
		margin-top: -5px;
	}

	.remember-me {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
	}

	.forgot-pwd {
		color: #999;
		text-decoration: none;
	}

	.forgot-pwd:hover {
		color: #ff9900;
	}

	.bottomButton {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.submit-btn {
		width: 152px;
		padding: 10px;
		background-color: #FE8E04;
		color: white;
		border-radius: 4px;
		border: 1px solid #ff9900;
		font-size: 16px;
		cursor: pointer;
		margin-top: 10px;
	}

	.submit-btn:hover {
		background-color: #e68a00;
	}

	.register-btn {
		width: 152px;
		padding: 10px;
		background-color: #fff;
		color: #FE8E04;
		border: 1px solid #FE8E04;
		border-radius: 4px;
		font-size: 16px;
		cursor: pointer;
		margin-top: 10px;
	}

	.register-btn:hover {
		background-color: #fff5e6;
	}

	.modal-footer {
		margin-top: 25px;
		text-align: center;
		border-top: 1px solid #eee;
		padding-top: 15px;
	}

	.wechat-login {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		color: #666;
		font-size: 12px;
	}

	.wechat-icon img {
		width: 40px;
		height: 40px;
	}

	.wechat-login:hover span {
		color: #07c160;
	}

	.wechat-qrcode-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px 0;
	}

	.qrcode-box {
		width: 300px;
		height: 400px;
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
		border-radius: 4px;
		/* overflow: hidden; */
		/* border: 1px solid #eee; */
	}

	.qrcode-box img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.loading-text {
		color: #999;
		font-size: 14px;
	}

	.error-text {
		text-align: center;
		color: #ff4d4f;
		font-size: 14px;
		cursor: pointer;
	}

	.retry-text {
		margin-top: 5px;
		color: #ff9900;
		font-size: 12px;
		text-decoration: underline;
	}

	.scan-tip {
		font-size: 14px;
		color: #666;
		margin: 0;
	}
</style>